import * as React from 'react';
import { styled } from 'linaria/react';
import { RegionGroup, RegionWrapper } from './Region';
import { CommitButton, CancelButton } from './ChannelSelectorButtons';
import { LangCurrWrapper, SelectorBody, Title } from './ChannelSelector';
import { CheckboxWrapper } from '../Checkbox/CheckboxGroup';
const SelectorWrapper = /*#__PURE__*/styled('div')({
  name: "SelectorWrapper",
  class: "s11mrnvc"
});

const LargeSelector = ({
  children
}) => {
  return React.createElement(SelectorWrapper, null, children);
};

export default LargeSelector;

require("../../../../.linaria-cache/node_modules/@jetshop/ui/ChannelSelector/LargeSelector.linaria.css");